module.exports = __webpack_public_path__ + "static/media/6.1f1688dc.JPG";